import { Input } from '@envision/ev-ui-component-library'
import { useTranslation } from 'react-i18next'

type Props = {
  isRequired?: boolean
  label?: string

  formMethods: any
}

export default function RfidNumber({ isRequired, label, formMethods }: Props) {
  const { t } = useTranslation('rfid')

  const validation = {
    required: isRequired ? t('external_rfid_common_required') : '',
  }

  return (
    <Input
      id="visibleId"
      label={label ? label : t('contact_form_label_rfid_number')}
      validation={validation}
      formMethods={formMethods}
    />
  )
}
